<form>
  <div *ngIf="showToolTip" class="fakeTooltip">Link copied!</div>
  <div style="display: flex">
    <vng-input placeholder="Invite Link" name="flyshareInviteLink" [ngModel]="value" [disabled]="true"
      class="copy-link-field">
      <button vngSuffix vng-button variant="primary" type="button" (click)="copyLink()" style="height: 100%;">
        Copy Link
      </button>
    </vng-input>
  </div>
</form>